import { render, staticRenderFns } from "./SiderBar.vue?vue&type=template&id=c64fe50e&scoped=true"
import script from "./SiderBar.vue?vue&type=script&lang=js"
export * from "./SiderBar.vue?vue&type=script&lang=js"
import style0 from "./SiderBar.vue?vue&type=style&index=0&id=c64fe50e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64fe50e",
  null
  
)

export default component.exports